import { Auth } from 'aws-amplify';

export async function authHeader(): Promise<Object> {
  return {
    Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
  };
}

export async function getUserEmail(): Promise<string | null> {
  return (await Auth.currentAuthenticatedUser()).attributes.email;
}
